"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pkgName = 'gatsby-source-sanity';
var getGatsbyImageProps_1 = require("./images/getGatsbyImageProps");
exports.getFluidGatsbyImage = getGatsbyImageProps_1.getFluidGatsbyImage;
exports.getFixedGatsbyImage = getGatsbyImageProps_1.getFixedGatsbyImage;
var resolveReferences_1 = require("./util/resolveReferences");
exports.resolveReferences = resolveReferences_1.resolveReferences;
//# sourceMappingURL=index.js.map